import { OMIT_STATES, VALID_STATES } from './utils';

// Maps accent color short names to their corresponding background and text colors
var lozengeAccentStyles = {
  blue: {
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    color: "var(--ds-text-accent-blue, #0055CC)"
  },
  gray: {
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    color: "var(--ds-text-accent-gray, #44546F)"
  },
  green: {
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    color: "var(--ds-text-accent-green, #216E4E)"
  },
  lime: {
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    color: "var(--ds-text-accent-lime, #4C6B1F)"
  },
  magenta: {
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    color: "var(--ds-text-accent-magenta, #943D73)"
  },
  orange: {
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    color: "var(--ds-text-accent-orange, #A54800)"
  },
  purple: {
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    color: "var(--ds-text-accent-purple, #5E4DB2)"
  },
  red: {
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    color: "var(--ds-text-accent-red, #AE2E24)"
  },
  teal: {
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    color: "var(--ds-text-accent-teal, #206A83)"
  },
  yellow: {
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    color: "var(--ds-text-accent-yellow, #7F5F01)"
  }
};
export var extractState = function extractState(jsonLd) {
  var state = jsonLd['atlassian:state'];
  if (state) {
    if (typeof state === 'string') {
      var linkState = state.toLowerCase();
      if (!OMIT_STATES.includes(linkState)) {
        return {
          text: linkState,
          appearance: VALID_STATES[linkState] || 'default'
        };
      }
    } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
      if (state.name) {
        var accent = state.accent;
        return {
          text: state.name,
          appearance: state.appearance || 'default',
          style: accent ? lozengeAccentStyles[accent] : undefined
        };
      }
    }
  }
};